module.exports = __webpack_public_path__ + "d76cb7b6f4006efdd4764b35416d28b8.png";